// Free of any liquidjs dependency, so form validators can import it without
// pulling the liquid engine and its module-scope setup into their import graph.

// A complete Liquid output tag `{{ … }}` or tag `{% … %}`.
export const LIQUID_SYNTAX_REGEX = /\{\{.*?\}\}|\{%.*?%\}/;

/** True when a string contains Liquid output (`{{ }}`) or tag (`{% %}`) syntax. */
export function containsLiquidSyntax(value: string): boolean {
  return LIQUID_SYNTAX_REGEX.test(value);
}
